exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.inline img[data-v-2f23869a], .inline canvas[data-v-2f23869a], .inline .placeholder[data-v-2f23869a] {\n  height: 600px;\n  width: 900px;\n  position: absolute;\n}\n.placeholder[data-v-2f23869a] {\n  background-color: rgba(0, 0, 0, 0.05);\n}\ncanvas[data-v-2f23869a] {\n  -webkit-filter: blur(10px);\n          filter: blur(10px);\n}\n.blur-transition[data-v-2f23869a] {\n  transition: opacity linear .4s 0s;\n  opacity: 1;\n}\n.blur-enter[data-v-2f23869a], .blur-leave[data-v-2f23869a] {\n  opacity: 0;\n}\n.backgroundImage[data-v-2f23869a] {\n  min-height: 100%;\n  min-width: 100%;\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: cover;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2f23869a","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/BlurryImage.vue
// module id = 637
// module chunks = 3